import { SkapaTheme } from '@inter-ikea-kompis/themes';

export const colors = {
  textBlack: SkapaTheme.color.text.default || '#484848', //Skapa standard: body text
  textDark: SkapaTheme.color.dark || '#111111', //Skapa standard: darker text than default text
  heading: SkapaTheme.color.text.dark || '#111111', //Skapa standard: heading and emphasised, #111
  textLightest: SkapaTheme.color.text.lightest || '#767676', //Skapa standard: ligthest accesibble body text
  white: SkapaTheme.color.text.inverse || '#ffffff', //Skapa standard: text, border, icon on dark backgrounds. default background color.
  textDisabled: SkapaTheme.color.disabled.default || '#DFDFDF', //Skapa standard: disabled
  darkergray: '#333',
  darkgray: '#444',
  gray: '#666', //we use it for printing overview
  grayRgb: '102, 102, 102', // We use this with rgba to get some opacity in modals (same as gray above).
  lightgray: '#999',
  grey100: SkapaTheme.color.neutral.grey100 || '#f5f5f5', 
  grey200: SkapaTheme.color.neutral.grey200 || '#dfdfdf', 
  lightergray: SkapaTheme.color.neutral.grey300 || '#CCC', 
  lightestgray: '#EEE',
  offwhite: '#FAFAFA',
  lighterblue: '#769FC5',
  familyblue: SkapaTheme.color.commercialMessage.family || '#007CC1',
  blue: SkapaTheme.color.semantic.informative || '#0058A3',
  blueActive: '#004682',
  blueHover: '#004682',
  darkerblue: '#366796',
  clearBlue: '#037AE2',
  black: '#000000',
  red: '#E82C0C',
  btRed: '#FF0000',
  orange: '#FF6600',
  yellow: '#FFAC03',
  yellowRgb: '255, 172, 3', // For rgba to get opacity (same as yellow above).
  btYellow: '#FFD000',
  btYellowHover: '#d3ad07',
  btYellowActive: '#AF910C',
  green: '#178A00',
  schematicLineGray: '#979797',
  schematicTextBlack: '#262626',
};
